export function openPdfFile(fileData) {
    const pdf = new Blob([fileData], { type: 'application/pdf' })
    const pdfURL = URL.createObjectURL(pdf)

    window.open(pdfURL, '_blank')
}